import React from 'react'
import styles from './index.module.css'
import { BottomSheet, Button, Form, Typography } from '@s4l/ds'
import { useS4LContext } from '@s4l/react-context'
import { IconFilter } from '@s4l/icons/IconFilter'
import { cn, type UtilityClassNames } from '@s4l/utility-css'
import { IconTrash } from '@s4l/icons/IconTrash'

interface IFilterLayoutProps {
  children: React.ReactNode
}

export const FilterLayout = ({ children }: IFilterLayoutProps) => {
  const { i18n } = useS4LContext()
  const [isOpen, setIsOpen] = React.useState(false)
  const onSubmit = () => {
    setIsOpen(false)
  }

  return (
    <>
      <BottomSheet open={isOpen} onClose={() => setIsOpen(false)}>
        <BottomSheet.Trigger asChild>
          <Button
            className={['display-flex', 'desktop:display-none'].join(' ') as UtilityClassNames}
            variant="outlined-rounded"
            leadingIcon={<IconFilter size={16} />}
            data-testid="filter"
            size="small"
            fullWidth
            onClick={() => setIsOpen(true)}
          >
            <div className={styles.filtersHeader}>
              {i18n.formatMessage({ id: 'global.filters' })}
              <Form.CountBadge />
            </div>
          </Button>
        </BottomSheet.Trigger>
        <BottomSheet.Content
          scroll
          title={
            <div className={styles.filtersHeader}>
              {i18n.formatMessage({ id: 'global.filters' })}
              <Form.CountBadge size="medium" />
            </div>
          }
          footer={
            <>
              <Form.ClearButton data-testid="buttonReset" fullWidth icon={<IconTrash />}>
                {i18n.formatMessage({ id: 'link.clear' })}
              </Form.ClearButton>

              <Form.SubmitButton fullWidth onClick={onSubmit}>
                {i18n.formatMessage({ id: 'button.apply' })}
              </Form.SubmitButton>
            </>
          }
        >
          {children}
        </BottomSheet.Content>
      </BottomSheet>
      <div className={cn(['display-none', 'desktop:display-block'])}>
        <div className={styles.filtersHeader}>
          <Typography as="h6" variant="title" size="xs">
            {i18n.formatMessage({ id: 'global.filters' })}
          </Typography>
          <Form.CountBadge size="medium" />
        </div>
        {children}
      </div>
    </>
  )
}

FilterLayout.displayName = 'SearchFilters.FilterLayout'
export default FilterLayout
